export const DASHBOARD_LIST_REQUEST = "DASHBOARD_LIST_REQUEST";
export const DASHBOARD_LIST_SUCCESS = "DASHBOARD_LIST_SUCCESS";
export const DASHBOARD_LIST_ERROR = "DASHBOARD_LIST_ERROR";
